import React, { useEffect, useRef } from 'react';
import { OPTIONAL_COLUMNS } from './templateSchema';

/**
 * Dropdown menu for toggling which optional columns are visible in the editor.
 * Anchored below the settings icon; closes on outside click.
 */
function ColumnSettingsMenu({ visibleColumns, onChange, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [onClose]);

  const toggle = (key) => {
    const set = new Set(visibleColumns);
    if (set.has(key)) set.delete(key);
    else set.add(key);
    onChange(Array.from(set));
  };

  return (
    <div className="col-settings-menu" ref={ref}>
      <div className="col-settings-header">Visible Columns</div>
      <div className="col-settings-hint">Toggle optional attributes shown while editing and in the preview.</div>
      <div className="col-settings-list">
        {OPTIONAL_COLUMNS.map((c) => {
          const checked = visibleColumns.includes(c.key);
          return (
            <label key={c.key} className="col-settings-item">
              <input type="checkbox" checked={checked} onChange={() => toggle(c.key)} />
              <span className="col-settings-item-label">
                <strong>{c.label}</strong>
                <span className="col-settings-item-hint">{c.fullLabel}</span>
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}

export default ColumnSettingsMenu;
